import { flattenedTranslations } from '/src/common/general-utils.js';
/**
 * Middleware to load language labels and set it to VueI18n
 */
export default async function (to) {
  const route = to;
  const app = useNuxtApp();
  const store = app.$store;

  // If middleware is called from hot module replacement, ignore it
  if (/^(\/login|\/forgot-password|\/reset-password|\/verify-otp|\/form).*/gi.test(route.path) || app.isHMR) return;
  //fetch languages and if no language available then set fallbacklanguage for labels
  let { availableLanguages } = store.state;
  let baseLanguageObj = store.getters.baseLanguage;
  let baseLang = baseLanguageObj ? baseLanguageObj.LanguageCode : app.$i18n.global.fallbackLocale;
  let preferredLanguage = app.$i18n.global.fallbackLocale;
  // check if multi language enabled
  if (store.getters.showFeatureUser('ENABLE_MULTILANGUAGE', false)) {
    // use either user's preferred language or browser's language
    preferredLanguage = store.state['user-login'].user.Language || navigator.language || navigator.userLanguage;
    //for scenarios like en-US
    if (preferredLanguage.indexOf('-') >= 0) {
      preferredLanguage = preferredLanguage.substring(0, preferredLanguage.indexOf('-'));
    }
    //if preferred language is not available
    if (!availableLanguages.find((language) => language.LanguageCode === preferredLanguage)) {
      preferredLanguage = baseLang;
    }
  }
  // fetch translations only if its not already loaded
  if (!store.state.loadedLanguages?.includes(preferredLanguage)) {
    const translations = await store.dispatch('labels-common/getLabelTranslations', {
      lang: preferredLanguage.toLowerCase(),
      baseLang
    });

    app.$i18n.global.setLocaleMessage(preferredLanguage, flattenedTranslations(translations));
    app.$i18n.global.locale = preferredLanguage;

    await store.dispatch('changeLanguage', preferredLanguage);
  }
}
